// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "MiniCard-module--bx--text-truncate--end--ED0Yw";
export var bxTextTruncateFront = "MiniCard-module--bx--text-truncate--front--Z0iSs";
export var card = "MiniCard-module--card--+rGOW";
export var icon = "MiniCard-module--icon--ru6aR";
export var image = "MiniCard-module--image--P7SVP";
export var title = "MiniCard-module--title--v6DHH";
export var wrapper = "MiniCard-module--wrapper--d+Lhz";